import React from "react";
import { Col, Container, Row } from "reactstrap";
import { FirebaseConfig } from "utils/getFirebaseConfig";

interface FooterProps {
  isSettingFooter?: boolean;
  firebaseConfig?: FirebaseConfig | null;
}

const Footer = ({
  isSettingFooter = false,
  firebaseConfig = null,
}: FooterProps) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            {!isSettingFooter && (
              <Col sm={6}>{new Date().getFullYear()} © EaziQuote</Col>
            )}
            <Col sm={isSettingFooter ? 12 : 6}>
              <div
                className={
                  isSettingFooter
                    ? "text-sm-start"
                    : "text-sm-end d-none d-sm-block"
                }
              >
                {isSettingFooter ? (
                  <>
                    <a
                      href={
                        firebaseConfig?.termsOfService &&
                        firebaseConfig?.termsOfService.trim().length > 0
                          ? firebaseConfig.termsOfService
                          : "https://eaziquote-landing.silverskytechnology.com/terms-and-conditions/"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-muted me-3 terms-link"
                    >
                      Terms of Service
                    </a>
                    <a
                      href={
                        firebaseConfig?.privacyPolicy &&
                        firebaseConfig?.privacyPolicy.trim().length > 0
                          ? firebaseConfig.privacyPolicy
                          : "https://eaziquote-landing.silverskytechnology.com/privacy-policy/"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-muted terms-link"
                    >
                      Privacy Policy
                    </a>
                  </>
                ) : (
                  "Design & Develop by Silversky Technology"
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
